import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import Button from 'components/base/Button';

import { Col, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import {
  faCalendarDays,
  faDice,
  faPhotoFilm,
  faUserGear
} from '@fortawesome/free-solid-svg-icons';

import { useTranslation } from 'react-i18next';

export interface DropdownData {
  label: string;
  icon: IconProp;
  link: string;
}

const dropdownData: DropdownData[] = [
  {
    label: 'users.profilenavigation.my_calendar',
    icon: faPhotoFilm,
    link: '/dashboard/home'
  },
  {
    label: 'users.profilenavigation.events',
    icon: faCalendarDays,
    link: '/dashboard/home'
  },
  {
    label: 'users.profilenavigation.my_rewards',
    icon: faDice,
    link: '/dashboard/home'
  },
  {
    label: 'users.profilenavigation.my_curriculum',
    icon: faUserGear,
    link: '/my-curriculum'
  },
];



const ProfileNavigation = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <Row className={classNames(className, 'g-0')}>
      {dropdownData.slice(0, 6).map((item, index) => (
        <Col
          key={index}
          xs={6}
          className={classNames('border-1 py-2', {
            'border-bottom border-end': index === 0 || index === 2,
            'border-bottom': index === 1 || index === 3,
            'border-end': index === 4
          })}
        >
          <Button
            as={Link}
            to="#!"
            variant="link"
            className={classNames(
              'fs-8 text-800 hover-primary fw-semi-bold d-flex flex-column d-xxl-inline-block align-items-center align-items-xxl-start',
              {
                'ps-2': index % 2 === 0
              }
            )}
            startIcon={
              <FontAwesomeIcon
                icon={item.icon}
                className="me-2 mb-2 mb-xxl-0"
              />
            }
          >
            <Link className="text-1000" to={item.link}>
              {t(item.label)}
            </Link>

          </Button>
        </Col>
      ))}
    </Row>
  );
};

export default ProfileNavigation;
